import Vue from 'vue';
import App from './App';

import RefreshButton from "./RefreshButton";
import StatusChip from "./StatusChip";
import StatusIcon from "./StatusIcon";
import PresentationIcon from "../pages/presentations/components/PresentationIcon";
import PresentationBreadcrumbs from "../pages/presentations/components/PresentationBreadcrumbs";
import PresentationToolbar from "../pages/presentations/components/PresentationToolbar";

Vue.component('presentation-breadcrumbs', PresentationBreadcrumbs);
Vue.component('presentation-icon', PresentationIcon);
Vue.component('presentation-toolbar', PresentationToolbar);
Vue.component('refresh-button', RefreshButton);
Vue.component('status-chip', StatusChip);
Vue.component('status-icon', StatusIcon);

export {App}
